import React, { Fragment } from 'react'
import { func } from 'prop-types'
import {Row, Col } from '@paypalcorp/pp-react'
import {serverData } from '../../utils'
import { Sections } from '../../components'
import {
  privacySections,
  dataPlatformSections,
} from '../../config'
const { isInFrame = '' } = serverData

function iframeHeight(controlHeight) {
  if (controlHeight === true) {
      setTimeout(() => {
          if (typeof parent.iframeAutoHeight === 'function') {
              parent.iframeAutoHeight(0);
          }
      }, 1000);
  } else if (typeof parent.iframeAutoHeight === 'function') {
      parent.iframeAutoHeight(0);
  }
}


const MerchantSubHeader = ({ onSectionClick }) => {
  if(isInFrame !== undefined) {
    iframeHeight(true)
  }
  return (
    <Row className="one-section-only">
      <Col>
      <Fragment>
            <Sections
              sections={privacySections}
              onSectionClick={onSectionClick}
            />
            <Sections
              sections={dataPlatformSections}
              onSectionClick={onSectionClick}
            />
          </Fragment>
      </Col>
    </Row>
  )
}

MerchantSubHeader.propTypes = {
  onSectionClick: func.isRequired,
}

export default MerchantSubHeader
